export class ProductApplicabilityScRequest {
  legacyMatrixCode: string;
  labSCode?: string;
  accountCode?: string;
}
